export default "__VITE_ASSET__BCmgupAr__"